// src/directives/svg.js
// used for custom SVG icons
export default {
    beforeMount(el, binding) {
      el.innerHTML = binding.value;
    },
    updated(el, binding) {
      el.innerHTML = binding.value;
    }
  };